export default __webpack_public_path__ + "static/media/nacoboost.d4b0191b.jpg";